module.exports = __webpack_public_path__ + "static/media/Bought.711d9388.png";